import { API } from '@/shared/api/modules';
import type { GetFacilityOccupancyForecastRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilityOccupancyForecastQueryOptions = (
  params: GetFacilityOccupancyForecastRequestDto
) =>
  queryOptions({
    queryKey: ['single-facility-occupancy-forecast', params],
    queryFn: async ({ signal }) => {
      return await API.facilities.getFacilityOccupancyForecast(params, {
        signal,
      });
    },
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!params.facilityId,
  });
